import { render, staticRenderFns } from "./OptionalTaskComponent.vue?vue&type=template&id=79b82e60&scoped=true&"
import script from "./OptionalTaskComponent.vue?vue&type=script&lang=js&"
export * from "./OptionalTaskComponent.vue?vue&type=script&lang=js&"
import style0 from "./OptionalTaskComponent.vue?vue&type=style&index=0&id=79b82e60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b82e60",
  null
  
)

export default component.exports